import React from 'react';

const Hero = () => {
  return (
    <section id="home" className="relative h-screen w-full overflow-hidden">
      {/* Background Video/Image Slider */}
      <div className="absolute inset-0">
        <div className="relative w-full h-full flex flex-col md:flex-row">
          {/* Left Image - Indoor Cricket Nets with Bowling Machine */}
          <div
            className="w-full md:w-1/2 h-1/2 md:h-full bg-cover bg-center relative"
            style={{
              backgroundImage: `url('https://static.prod-images.emergentagent.com/jobs/3f99f446-135c-4dc7-8f47-31d62cfa3996/images/08cedd94443d351c03cb361a0482ee5a3e42610565d3f0745f525c6eaf4e9783.png')`,
            }}
          >
            <div className="absolute inset-0 bg-black/50"></div>
          </div>
          {/* Right Image - Batsman Facing Bowling Machine */}
          <div
            className="w-full md:w-1/2 h-1/2 md:h-full bg-cover bg-center relative"
            style={{
              backgroundImage: `url('https://static.prod-images.emergentagent.com/jobs/3f99f446-135c-4dc7-8f47-31d62cfa3996/images/5c7459c6963bd8f142f18abe125ff5260350ef9004c808f8ffdf7426ff577ff2.png')`,
            }}
          >
            <div className="absolute inset-0 bg-black/50"></div>
          </div>
        </div>
      </div>

      {/* Hero Content - Centered */}
      <div className="absolute inset-0 flex flex-col items-center justify-center z-10 px-4">
        {/* Main Title */}
        <h1 className="text-white text-4xl sm:text-5xl md:text-7xl font-bold tracking-wider text-center" style={{ fontFamily: 'Georgia, serif' }}>
          GOD OF CRICKET
        </h1>
        
        {/* Tagline */}
        <p className="text-white/90 text-sm sm:text-base md:text-lg mt-4 text-center max-w-md md:max-w-xl tracking-wide">
          Premier Indoor Cricket Training Academy in Tirupati
        </p>
        <p className="text-white/70 text-xs sm:text-sm mt-2 text-center">
          Professional Nets • Bowling Machines • Expert Coaching
        </p>

        {/* Book Now Button */}
        <a 
          href="#contact"
          className="mt-8 bg-white text-black px-8 sm:px-12 py-3 sm:py-4 text-xs sm:text-sm tracking-[0.2em] sm:tracking-[0.3em] hover:bg-gray-200 transition-all duration-300 font-semibold inline-block"
          data-testid="hero-book-now-btn"
        >
          BOOK NOW
        </a>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce hidden md:block">
        <svg className="w-6 h-6 text-white/70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </section>
  );
};

export default Hero;
